import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'kt-subscriptions-dialog',
  templateUrl: './subscriptions-dialog.component.html',
  styleUrls: ['./subscriptions-dialog.component.scss']
})
export class SubscriptionsDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<SubscriptionsDialogComponent>,
    private translates: TranslateService,
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }
  getSelectedLanguage() {
    return localStorage.getItem('language') || this.translates.getDefaultLang();
  }
  openSubscription(type: string) {
    if (type === 'month' && this.getSelectedLanguage() === 'de') {
      window.open('https://mindfield-shop.com/produkt/esense-supervisor-account-fuer-esense-mobile-app-und-esense-live/', '_blank')
    }
    if (type === 'month' && this.getSelectedLanguage() === 'en') {
      window.open('https://mindfield-shop.com/en/product/esense-supervisor-account-monthly-subscription-for-esense-app-and-esense-live/', '_blank')
    }
  }
}
